import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=047cd5dc&scoped=true&"
import script from "./PasswordSetting.vue?vue&type=script&lang=ts&"
export * from "./PasswordSetting.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordSetting.vue?vue&type=style&index=0&id=047cd5dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047cd5dc",
  null
  
)

export default component.exports